import pickBy   from 'lodash/pickBy';
import identity from 'lodash/identity';

/**
 * Delete empty and null properties from object
 * @param translations
 */
export const deleteEmptyPropertiesFromObject = (obj: object) => {
	Object.keys(obj).forEach((key) => {
		obj[key] = pickBy(obj[key], identity);
	});

	Object.keys(obj).forEach((key) => {
		if (!Object.keys(obj[key]).length) {
			delete obj[key];
		}
	});
};
